

































































































import * as Diff from 'diff'
import Vue from 'vue'
import VisualDiff from '@/components/visual-diff.vue'

export default Vue.extend({
  components: {
    VisualDiff,
  },
  props: {
    'item': {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    showDiff: false,
  }),
  computed: {
    result(): any {
      return this.item.result
    },
    sample(): any {
      return this.item.sample
    },
    diff(): any {
      const diff = {}
      if (this.result && this.sample) {
        diff['title'] = Diff.diffWordsWithSpace(this.sample.title, this.result.title)
        diff['text'] = Diff.diffWordsWithSpace(this.sample.text, this.result.text)
      }
      return diff
    },
  },
})
